import {Component, Injector} from '@angular/core';
import {YmlService} from "../yml.service";
import {YmlModel} from "../../model/yml.model";
import {ColumnType, GeneralListComponent} from "../../shared/general-list/general-list.component";

@Component({
    selector: 'app-yml-list',
    templateUrl: '../../shared/general-list/general-list.component.html',
    standalone: false
})
export class YmlListComponent extends GeneralListComponent {

  items: YmlModel[];

  constructor(
    injector: Injector,
    private ymlService: YmlService
  ) {
    super(injector);
    this.showNewBtn = true;
    this.title = this.ymlService.getTranslation("YML_FILES");

    this.columns = [
      {id: 'id',label: 'ID', type: ColumnType.Simple},
      {id: 'name',label: this.ymlService.getTranslation("NAME"), type: ColumnType.Simple},
      {id: 'description',label: this.ymlService.getTranslation("DESCRIPTION"), type: ColumnType.Simple},
      {id: 'priority',label: this.ymlService.getTranslation("PRIORITY"), type: ColumnType.Simple},
      {id: 'type',label: this.ymlService.getTranslation("TYPE"), type: ColumnType.Simple},
      {id: 'modified',label: this.ymlService.getTranslation("MODIFIED"), type: ColumnType.Simple},
      {id: 'modifiedBy',label: this.ymlService.getTranslation("MODIFIEDBY"), type: ColumnType.Simple},
      {id: 'action', label: 'edit', type: ColumnType.Action}
    ];
  }

  fetchItems() {
    this.ymlService.getItems().subscribe((resp:any) => {
      if (resp) {
        this.items = resp.map(r => new YmlModel(r));
        this.dataSource.data = this.items;
      }
    })
  }

}
